<template>
  <div class="index">
    <div class="header">
      <img src="../assets/logo.jpg" alt="">
      <!-- <h3>闻源漫画-快看引流平台</h3> -->
      <!-- <h3>闻源漫画-腾讯引流平台</h3> -->
      <!-- <h3>闻源漫画-漫画人引流平台</h3> -->
      <!-- <h3>闻源漫画-漫漫引流平台</h3> -->
      <h3>闻源漫画-奇热引流平台</h3>


    </div>
    <div class="container">
      <div class="item" v-for="(item,index) in list" :key="'mh'+index" @click="toDetail(item.id)">
        <div class="img">
          <img :src="item.url" alt="">
          <div class="cover"></div>
        </div>
        <div class="detail">
          <h3 class="title">{{item.name}}</h3>
          <p class="author">作者：{{item.author}}</p>
          <div class="desc">
            标签:
            <span v-for="(itm,idx) in item.desc" :key="'desc'+idx">{{itm}}</span>
          </div>
          <div class="instr">
            <span>漫画简介</span>
            <div>{{item.instr}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import list from '../util/list';//快看
// import list from '../util/txlist';//腾讯
// import list from '../util/wblist';//微博
// import list from '../util/mmlist';//漫漫
import list from '../util/qrlist';//奇热
// import list from '../util/yqlist';//瑛麒


import _isMobile from '../util/util';

export default {
  data() {
    return {
      list: list
    }
  },
  mounted() {
    if (_isMobile()) {
      // alert("手机端");
      this.$router.replace('/m');
    } else {
      // alert("pc端");
      this.$router.replace('/');
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    toDetail(id){
      this.$router.push({path:`\detail?id=${id}`})
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  min-width: 1200px;
  padding-bottom: 50px;

  .header {
    height: 80px;
    // background-color: #ff9a6a;
    background-color: #fff;
    // background-color: #000;
    // color: #fff;
    display: flex;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    align-items: center;
    justify-content: center;

    img {
      width: 40px;
      height: 40px;
    }

    h3 {
      display: inline-block;
      text-align: center;
      margin-left: 20px;
      font-size: 30px;
    }
  }

  .container {
   padding: 80px 0;
    width: 1200px;
    margin: 0 auto;
    // padding: 30px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .item {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      &:nth-child(2n) {
        margin-left: 60px;
      }

      .img {
        width: 220px;
        cursor: pointer;
        position: relative;

        &:hover {
          .cover {
            opacity: 1;
          }
        }

        .cover {
          transition: all .3s;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, .2);
          opacity: 0;
        }

        img {
          border-radius: 10px;
        }
      }

      .detail {
        width: 300px;
        margin-left: 20px;
        text-align: left;
        // padding: 30px 0;
        font-size: 14px;
        color: #333;

        h3 {
          color: #000;
          font-size: 18px;
        }

        .author {
          margin-top: 5px;
        }

        .instr {
          margin-top: 20px;

          span {
            display: inline-block;
            position: relative;
            border-bottom: 2px solid #f5ce03;
            margin-bottom: 10px;
            cursor: pointer; 
          }

          div {
            text-indent: 2em;
          }
        }

        .desc {
          margin-top: 10px;

          span {
            display: inline-block;
            border: 1px solid #ddd;
            padding: 0px 10px;
            border-radius: 15px;
            margin-left: 10px;

            &:nth-child(1) {
              margin-left: 0;
            }

          }
        }
      }
    }
  }

}
</style>